import { Database } from "lucide-react";
import { getSupabaseEnvironment } from "@/lib/supabaseEnvironment";
import { useAuth } from "@/context/AuthContext";

const toneClasses = {
  local: "border-emerald-300 bg-emerald-100 text-emerald-950 shadow-emerald-900/10",
  cloud: "border-rose-300 bg-rose-100 text-rose-950 shadow-rose-900/10",
  unknown: "border-amber-300 bg-amber-100 text-amber-950 shadow-amber-900/10",
};
const PRODUCTION_BADGE_EMAIL_ALLOWLIST = new Set(["cameronjordanp@gmail.com"]);

export default function EnvironmentBadge() {
  const { user } = useAuth();
  const env = getSupabaseEnvironment();
  const canSeeProductionBadge = PRODUCTION_BADGE_EMAIL_ALLOWLIST.has(normalizeEmail(user?.email));

  if (env.label === "PRODUCTION" && !canSeeProductionBadge) return null;

  return (
    <div
      aria-label={`Database environment: ${env.label}. Supabase host: ${env.host}.`}
      data-testid="environment-badge"
      className={[
        "fixed left-0 right-0 top-0 z-[2147483647]",
        "pointer-events-none select-none border-b px-3 py-0.5",
        toneClasses[env.tone] ?? toneClasses.unknown,
      ].join(" ")}
    >
      <div className="mx-auto flex max-w-screen-2xl items-center justify-center gap-2 whitespace-nowrap text-[10px] font-black uppercase tracking-[0.16em]">
        <Database className="h-3.5 w-3.5" strokeWidth={2.5} />
        <span>Database: {env.label}</span>
        <span className="hidden max-w-[34vw] truncate font-semibold normal-case tracking-normal opacity-75 sm:inline">
          {env.host}
        </span>
      </div>
    </div>
  );
}

function normalizeEmail(email) {
  return String(email || "").trim().toLowerCase();
}
